import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'accounts'
const verb = 'get'

export default class OspreyAccountMetadata extends BaseAction {
    constructor() {
        const id = '83c8647f-dc9d-4bd4-807f-023ce680de13'
        const path = `/${resource}/metadata`
        super(resource, verb, path, id)
    }

    getMetadata(fields) {
        if (!fields) {
            fields = [ 'base', 'account' ]
        }

        if (Array.isArray(fields)) {
            fields = fields.join(',')
        }

        this.params = {
            fields
        }

        return fetchContentIfNeeded(this)
    }
}




// WEBPACK FOOTER //
// src/actions/osprey-api/accounts/accounts-metadata.js